import { createSelector } from 'reselect';

import { selectSubCompany } from './subCompany.selectors';

export const getSubCompanyNmlsLicenses = createSelector(
  selectSubCompany,
  ({ nmlsLicenses }) => nmlsLicenses,
);

export const getSubCompanyNmlsLicensesLoadError = createSelector(
  selectSubCompany,
  ({ nmlsLicensesStatus }) => nmlsLicensesStatus.loadError,
);
